export const setToken = (token, rememberMe, refreshToken) => {
  const expirationTime = rememberMe
    ? new Date().getTime() + 7 * 24 * 60 * 60 * 1000 // 7 days in ms
    : new Date().getTime() + 1 * 60 * 60 * 1000; // 1 hour in ms

  const tokenData = {
    token,
    refreshToken,
    expiresAt: expirationTime,
    rememberMe: rememberMe,
  };

  localStorage.setItem("auth", JSON.stringify(tokenData));
};

export const getToken = () => {
  const storedData = JSON.parse(localStorage.getItem("auth"));

  if (storedData) {
    const currentTime = new Date().getTime();

    if (currentTime < storedData.expiresAt) {
      return storedData.token;
    } else {
      removeToken();
      return null; // Token expired
    }
  }
  return null; // No token found
};

export const getJwtPayload = () => {
  const token = getToken();
  if (!token) return null;
  try {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(atob(base64).split('').map(function(c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));
    return JSON.parse(jsonPayload);
  } catch (e) {
    return null;
  }
};

export const removeToken = () => {
  localStorage.clear();
  sessionStorage.clear();
};
